import React from 'react';
import { ErrorWarningInfoModalViewStore } from '../stores';
import { setCurrentView } from 'core/utils';
import { ErrorWarningInfoModalTemplate } from 'themes/modules/modals/pages';

@setCurrentView((rootStore, componentProps) => new ErrorWarningInfoModalViewStore(rootStore, componentProps), 'ErrorWarningInfoModalViewStore')
class ErrorWarningInfoModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <ErrorWarningInfoModalTemplate {...this.props} />;
    }
}

export default ErrorWarningInfoModal;

